import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShoppingBag4"><Path fillRule="evenodd" clipRule="evenodd" d="M5.75 7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7H18.25C19.7688 7 21 8.23122 21 9.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V9.75C3 8.23122 4.23122 7 5.75 7ZM8.5 7C8.5 5.067 10.067 3.5 12 3.5C13.933 3.5 15.5 5.067 15.5 7H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
